<template>
<div>
  <div scope="public_profile,email" class="fb-login-button" data-size="medium" data-button-type="login_with" data-layout="rounded" data-auto-logout-link="false" data-use-continue-as="false" data-width="" onlogin="checkLoginState();"></div>
  <div id="status"></div>
</div>
</template>

<script>
export default {
  name: 'socialsignup'
}
</script>

<style scoped>
.login_separator {
    position: relative;
    margin: 5px 0;
    padding-top: 5px;
    padding-bottom: 5px;
}
.login_separator span {
    position: absolute;
    top: 10px;
    background-color: #fff;
    padding-left: 25px;
    padding-right: 25px;
    margin-left: -25px;
}

._8jan{
  height: auto !important;
}

._8jan:active {
  opacity: 0 !important;
}

</style>
